<template>
  <swiper
    :modules="modules"
    :spaceBetween="10"
    slidesPerView="auto"
    :navigation="{
      nextEl: nextEl,
      prevEl: prevEl,
    }"
    class="post-short-slider"
    @slideChange="onSlideChange"
  >
    <swiper-slide
      v-for="(image, index) in postImages"
      :key="index"
      class="post_short_slide"
    >
      <img
        :src="image.url"
        alt="Image"
        class="post_short_slide_img"
        loading="lazy"
      />
      <Bubble
        :trigger="visible"
        :image="post.metadata?.frames?.[index]?.bubbles_image_url || ''"
      />
    </swiper-slide>

    <swiper-slide class="post_short_slide info_slide">
      <div class="info_slide_content">
        <div class="info_slide_header">
          <div class="info_slide_text">
            <p class="username" @click.stop="openProfile(post.user.id)">
              {{ post.user.username }}
            </p>

            <span class="time_created">{{ formattedDate }}</span>
          </div>

          <ShareBtn :post="post" class="post_short_share" />
        </div>

        <section class="post_description" v-if="post.title">
          <img src="/tail.png" alt="Tail" class="tail" loading="lazy" />
          <p class="bubble">{{ post.title }}</p>
        </section>
      </div>

      <section class="post_bottom">
        <div class="post_bottom_btn">
          <LikeBtn :post="post" />
          <CommentBtn :post="post" @click.stop="openComments" />
        </div>
      </section>
    </swiper-slide>

    <!-- Кастомные стрелки с уникальными классами -->
    <div
      @click.stop
      ref="nextEl"
      :class="`swiper-button-next next-${post.id}`"
    ></div>
    <div
      @click.stop
      ref="prevEl"
      :class="`swiper-button-prev prev-${post.id}`"
    ></div>
  </swiper>
</template>

<script>
import { toRef, ref } from "vue";
import Bubble from "@/UI/Bubble.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import SwiperCore from "swiper";
import { Navigation } from "swiper/modules";
import { format, parseISO } from "date-fns";
import { ru, enUS } from "date-fns/locale";
import { usePostActions } from "@/composables/usePostActions";
import ShareBtn from "@/UI/Button/ShareBtn.vue";
import { useModalStore } from "@/stores/modalStore";
import { useOpenProfile } from "../../composables/useOpenProfile.js";
import CommentBtn from "../../UI/Button/CommentBtn.vue";
import LikeBtn from "../../UI/Button/LikeBtn.vue";

SwiperCore.use([Navigation]);

export default {
  name: "PostShortSlider",
  components: {
    Swiper,
    SwiperSlide,
    Bubble,
    ShareBtn,
    LikeBtn,
    CommentBtn,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      modules: [Navigation],
      nextEl: null,
      prevEl: null,
      activeIndex: 0,
      modal: useModalStore(),
      slidesPerView: 3,
      openProfile: useOpenProfile().openProfile,
      openComments: usePostActions(this.post, this.isModal, this.$emit)
        .openComments,
    };
  },
  methods: {
    onSlideChange(swiper) {
      this.activeIndex = swiper.activeIndex;
    },
  },
  computed: {
    imagesCount() {
      return Math.min(this.postImages.length, 4);
    },
    postImages() {
      const images = [];
      for (let index = 1; index <= 10; index++) {
        const pictureKey = `picture_${index}`;
        if (this.post[pictureKey]?.url) {
          images.push({
            url:
              import.meta.env.VITE_IMG_BASE_URL + this.post[pictureKey].related,
            id: index,
          });
        }
      }
      return images;
    },
    formattedDate() {
      if (!this.post.time_created) return "";
      return format(parseISO(this.post.time_created), "d MMM yyyy", {
        locale: this.$i18n.locale === "ru" ? ru : enUS,
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.nextEl = this.$refs.nextEl;
      this.prevEl = this.$refs.prevEl;
    });
  },
};
</script>

<style>
.post_short_slide {
  height: 100%;
  width: fit-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  transition-property: transform;
  border-radius: 15px;
  overflow: hidden;
  min-width: 150px;
}

.info_slide {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  aspect-ratio: 9 / 15;
  margin-right: 25px !important;
}

.info_slide_content {
  width: 100%;
}

.info_slide .username,
.info_slide .time_created {
  margin: 0;
}

.info_slide .username {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.info_slide .time_created {
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.info_slide .post_description {
  padding-left: 5px;
}

.tail {
  position: absolute;
  left: 44px;
  width: 20px;
  height: 18px;
}

.info_slide .post_description .tail {
  left: 0;
  top: -3px;
}

.info_slide .post_bottom {
  padding: 0;
  align-self: flex-start;
}

.info_slide .post_bottom .post_bottom_btn {
  gap: 5px;
}

.info_slide_header {
  display: flex;
  /* gap: 10px; */
  margin-bottom: 8px;
  width: 100%;
}

.info_slide_text {
  display: flex;
  flex-wrap: wrap;
}

.post_short_slide_img {
  height: 100%;
  display: block;
  object-fit: cover;
}

/* Кастомизация стрелок */
.swiper-button-prev,
.swiper-button-next {
  color: #fff !important;
  width: 48px !important;
  height: 48px !important;
  background: rgba(134, 134, 134, 0.2);
  backdrop-filter: blur(5px);
  border-radius: 15px;
  transition: all var(--transition-time) ease;
}

.swiper-button-prev {
  margin-left: 10px !important;
}

.swiper-button-next {
  margin-right: 10px !important;
}

.swiper-button-prev:hover,
.swiper-button-next:hover {
  background: rgba(206, 206, 206, 0.4);
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 16px !important;
  font-weight: 800;
}

.post-short-slider {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: auto;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.collage-container {
  display: grid;
  gap: 4px;
}

.collage-item {
  position: relative;
  overflow: hidden;
  min-height: 0;
}

.collage-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: relative;
}

.collage-2 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  object-position: center;
}

.collage-3 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.collage-3 .item-1 {
  grid-column: 1 / 3;
  object-position: center;
  grid-row: 2;
}

.collage-3 .item-2 {
  grid-column: 1;
}

.collage-3 .item-3 {
  grid-column: 2;
}

.collage-4 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.collage-item {
  position: relative;
  overflow: hidden;
  min-height: 0;
}
</style>
